import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Group, AdminUserView, Role, User } from 'src/app/state-management';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';

@Injectable()
export class AdminService {

    adminUrl = 'api/admin';
    graphMeEndpoint = 'https://graph.microsoft.com/v1.0';

    private handleError: HandleError;

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(
        private httpClient: HttpClient,
        httpErrorHandler: HttpErrorHandler
    ) {
        this.handleError = httpErrorHandler.createHandleError('AdminService');
    }

    getIsAdmin(): Observable<boolean> {
        return this.httpClient.get<boolean>(this.adminUrl + '/isadmin', this.httpOptions);
    }

    getUsers(): Observable<AdminUserView[]> {
        return this.httpClient.get<AdminUserView[]>(this.adminUrl + '/users', this.httpOptions);
    }

    getGroups(): Observable<Group[]> {
        return this.httpClient.get<Group[]>(`${this.adminUrl}/groups`, this.httpOptions);
    }

    getRoles(): Observable<Role[]> {
        return this.httpClient.get<Role[]>(`${this.adminUrl}/roles`, this.httpOptions);
    }

    createUser(newUser: AdminUserView): Observable<any> {
        return this.httpClient.post(`${this.adminUrl}/createUser`, newUser, this.httpOptions);
    }

    updateUser(user: AdminUserView): Observable<any> {
        return this.httpClient.post<any>(this.adminUrl + '/updateUser', user, this.httpOptions);
    }

    getADUsers(token: string): Promise<any> {
        return this.httpClient.get(`${this.graphMeEndpoint}/users?$top=999`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'ConsistencyLevel': 'eventual'
            }
        }).toPromise();
    }

    getADFilteredUsers(token: string, searchString: string): Promise<any> {
        return this.httpClient.get(`${this.graphMeEndpoint}/users?$search="displayName:${searchString}"&$orderby=displayName`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'ConsistencyLevel': 'eventual'
            }
        }).toPromise();
    }

    getPersonalADUserProfile(token: string): Promise<any> {
        return this.httpClient.get(`${this.graphMeEndpoint}/me`, {
            headers: { 'Authorization': `Bearer ${token}` }
        }).toPromise();
    }

    updateGroup(group: any): Observable<any> {
        return this.httpClient.post<any>(this.adminUrl + '/updateGroup', group, this.httpOptions);
    }

    updateRole(role: any): Observable<any> {
        return this.httpClient.post<any>(this.adminUrl + '/updateRole', role, this.httpOptions);
    }

    createGroup(newGroup: any): Observable<any> {
        return this.httpClient.post(`${this.adminUrl}/createGroup`, newGroup, this.httpOptions);
    }

    createRole(newRole: any): Observable<any> {
        return this.httpClient.post(`${this.adminUrl}/createRole`, newRole, this.httpOptions);
    }

    validateEdocsAlias(email: string, fullName: string): Observable<AdminUserView[]> {
        return this.httpClient.get<any>(`${this.adminUrl}/validateEdocsAlias?email=${email}&fullName=${fullName}`, this.httpOptions);
    }


}
